const PAGE_VIEW_WAIT_TIME = 1000

export const pageView = ({
    locale,
    localeLessPath,
    fullPath,
    pageType,
    viewtype,
    brandSlug,
    recommended,
    referrer,
    analyticTags,
    depth,
    otherBatchedPayload,
}) => {
    if (window.Store.isExcludedFromTracking) return false
    if (window.OCSessionData) {
        waitAndTriggerPageView({
            locale,
            localeLessPath,
            fullPath,
            pageType,
            viewtype,
            brandSlug,
            recommended,
            referrer,
            analyticTags,
            depth,
            otherBatchedPayload,
        })
    } else {
        window.getOCSessionData().then(() => {
            waitAndTriggerPageView({
                locale,
                localeLessPath,
                fullPath,
                pageType,
                viewtype,
                brandSlug,
                recommended,
                referrer,
                analyticTags,
                depth,
                otherBatchedPayload,
            })
        })
    }
}

const waitAndTriggerPageView = (payload) => {
    setTimeout(() => {
        triggerPageView(payload)
    }, PAGE_VIEW_WAIT_TIME)
}

const triggerPageView = ({
    locale,
    localeLessPath,
    fullPath,
    pageType,
    viewtype,
    brandSlug,
    recommended,
    referrer,
    analyticTags,
    depth,
    otherBatchedPayload,
}) => {
    // set custom referrers
    const orderchampWebsites = [
        'www.orderchamp.test',
        'www.orderchamp.dev',
        'www.orderchamp.com',
    ]
    const isOrderchampReferrer = orderchampWebsites?.some((el) =>
        referrer?.includes(el)
    )

    const experiment = window.Store.experiment
    const accountType = window.Store.accountType
    let customReferrer = ''
    let internalReferrer = ''
    if (referrer) {
        if (isOrderchampReferrer) {
            const url = new URL(referrer)
            const localePathnameRgx = /^\/[a-z]{2}\// // matches the referrers pathname, i.e. /nl/, /de/ etc.
            const localeLessPathname = url.pathname.replace(
                localePathnameRgx,
                '/'
            )
            customReferrer = new URL(localeLessPathname, referrer).toString()
            internalReferrer = url.pathname.replace(localePathnameRgx, '/')
        } else {
            customReferrer = referrer
        }
    }

    const params = {
        locale: locale || 'en',
        name: localeLessPath?.toLowerCase(),
        type: accountType?.toLowerCase(),
        pageTitle: document.title,
        path: localeLessPath?.toLowerCase(),
        url: `${window.location.protocol}//${window.location.hostname}${
            fullPath || ''
        }`.toLowerCase(),
        ...(pageType && { pageType }),
        ...(viewtype && { viewtype }),
        ...(brandSlug && { brandSlug }),
        ...(analyticTags && { analyticTags }),
        ...(depth && { depth: depth - 1 }), // soon to be depricated
        ...(depth && { level: depth }),
        ...(otherBatchedPayload && { ...otherBatchedPayload }),
        ...window.OCSessionData,
        recommended: recommended ? 'yes' : 'no',
        custom_referrer: customReferrer,
        internal_referrer: internalReferrer,
    }

    if (experiment) {
        params.exp = experiment.exp
        params.experiment_id = experiment.experiment_id
        params.experimentId = experiment.experimentId
        params.variant_id = experiment.variant_id
        params.variantId = experiment.variantId
    }

    window.analytics.page(localeLessPath?.toLowerCase(), params)

    if (!accountType) {
        // WARNING if you make a change in this part you have to copy it over to createSession.js
        window.analytics.ready(function () {
            if (window.fbq) {
                window.fbq('track', 'PageView')
            }
        })
    }
}
